'use strict';

function roleProvider() {
  var roles = {};

  return {
    use: use,
    $get: $get
  };

  function use(_roles) {
    roles = _roles;
  }

  function translate(role) {
    return roles[role];
  }

  function $get() {
    return {
      roles: roles,
      translate: translate
    };
  }
}

module.exports = roleProvider;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/provider/index.js
 ** module id = 185
 ** module chunks = 0
 **/